export enum SearchProviderType {
  TAVILY = 'tavily',
  SERPER = 'serper',
  PERPLEXITY = 'perplexity',
}
